import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.function.name";
import "core-js/modules/es.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.iterator";
import _objectWithoutProperties from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import "regenerator-runtime/runtime";
import _objectSpread from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import axios from 'axios';
import { isNewQQLogin } from './login';
import { buildCSRF } from './login/lib';
import extend from 'lodash-es/extend';
import isPlainObject from 'lodash-es/isPlainObject';
import { buildQueryStr } from './url';
export var RequestErrorType = {
  NETWORK_ERR: 'NETWORK_ERR',
  SYSTEM_ERR: 'SYSTEM_ERR',
  LOGIC_ERR: 'LOGIC_ERR'
};
var IS_STD_PROTOCOL = /^(http|https):$/.test(location.protocol);
var HTTP2HTTP_PROXY = 'https://access.video.qq.com/trans/';
var HTTP2HTTP_APPID = '68106135';
var HTTP2HTTP_SECRETKEY = 'e667570eb833960cc41051d498df1c233308eb195dba2cc3';
var METHODS = new Map([['get', function (url, params, options) {
  return axios(extend({
    url: url,
    params: params,
    method: 'get'
  }, options));
}], ['post', function (url, data, options) {
  return axios(extend({
    url: url,
    data: data,
    method: 'post'
  }, options));
}]]);
/**
 * 通用的请求错误描述类
 * @param code
 * @param msg
 * @param res
 * @constructor
 */

export function RequestError(code, msg, res, errorType) {
  this.code = code;
  this.msg = msg;
  this.res = res;
  this.errorType = errorType || RequestErrorType.LOGIC_ERR;
}

RequestError.prototype.toString = function () {
  return this.msg + (this.code ? "(".concat(this.code, ")") : '');
};

RequestError.prototype.RequestErrorType = RequestError.RequestErrorType = RequestErrorType;
/**
 * 通用请求
 * @param url
 * @param data
 * @param options axios的其他option 如 timeout 具体查看 https://github.com/axios/axios#axios-api
 * @return Promise
 */

export function request(_x) {
  return _request.apply(this, arguments);
}

function _request() {
  _request = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
    var data,
        options,
        csrfParam,
        type,
        others,
        method,
        res,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};

            if (isNewQQLogin() && url.match(/\/\/pay.video.qq.com/)) {
              // QQ互联迁移
              url = url.replace(/\/\/(pay.video.qq.com)/, '//access.video.qq.com/trans/$1');

              if (!isPlainObject(data)) {
                data = {};
              }

              csrfParam = buildCSRF();
              extend(data, {
                vappid: HTTP2HTTP_APPID,
                vsecret: HTTP2HTTP_SECRETKEY
              }, csrfParam);
            }

            if (!IS_STD_PROTOCOL && /^\/\//.test(url)) {
              url = "https:".concat(url);
            }

            type = options.type, others = _objectWithoutProperties(options, ["type"]);
            method = (type || 'get').trim().toLowerCase(); // 由于 axios 不支持 jsonp，需确保 url 参数带上 otype=xjson
            // 自动拼接 otype=xjson，以确保接口返回 json 对象数据

            if (url.indexOf('otype=') < 0) {
              url += "".concat(url.indexOf('?') > 0 ? '&' : '?', "otype=xjson");
            } else {
              url = url.replace('otype=json', 'otype=xjson');
            }

            if (method === 'post') {
              if (isPlainObject(data)) {
                // 兼容zepto的参数处理方式（如果要传json字符串，可以先调JSON.stringify(data)再传参；不建议直接传object，会触发预检，产生两次请求）
                data = buildQueryStr(data);
              }
            } // 用于请求携带cookie


            others.withCredentials = true;
            _context.prev = 9;
            _context.next = 12;
            return METHODS.get(method).call(this, url, data, others);

          case 12:
            res = _context.sent;

            if (!(res && res.status === 200 && res.data)) {
              _context.next = 17;
              break;
            }

            return _context.abrupt("return", res.data);

          case 17:
            throw new RequestError(0, '服务器开小差了！请重试', null, RequestErrorType.NETWORK_ERR);

          case 18:
            _context.next = 24;
            break;

          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](9);
            console.log(_context.t0);
            throw new RequestError(0, '网络开小差了！请重试', null, RequestErrorType.NETWORK_ERR);

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[9, 20]]);
  }));
  return _request.apply(this, arguments);
}

export function nRequest(url) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return request(_formatNodeAPIUrl(url, args), null, {
    dataType: 'json'
  }).then(function (_ref) {
    var ret = _ref.ret,
        msg = _ref.msg,
        data = _ref.data;

    if (ret !== 0) {
      throw new RequestError(ret, msg, null, RequestErrorType.LOGIC_ERR);
    }

    return data;
  });
}

function _formatNodeAPIUrl(url, args) {
  if (!args.length) {
    return url;
  }

  var i = 0;
  return url.replace(/%(s|n)/g, function (m) {
    var v = args[i++];

    if (v === undefined || v === null) {
      v = '';
    }

    switch (m) {
      case '%n':
        return v;

      case '%s':
      default:
        return "\"".concat(v, "\"");
    }
  });
}

export function http2http(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return request("".concat(HTTP2HTTP_PROXY).concat(url.replace(/^(https:|http:)?\/\//, '')), _objectSpread(_objectSpread({}, params), {}, {
    vappid: HTTP2HTTP_APPID,
    vsecret: HTTP2HTTP_SECRETKEY
  }, buildCSRF()), options);
}
export function commConfig(configId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return commCGI({
    name: 'spp_get_confi',
    cmd: 1
  }, _objectSpread({
    config_id: configId
  }, params), options);
}
export function commCGI(_ref2) {
  var name = _ref2.name,
      cmd = _ref2.cmd;
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var isJson = options.dataType && options.dataType.toLowerCase() === 'json';

  if (options.withCredentials === true) {
    options = _objectSpread({
      xhrFields: {
        withCredentials: true
      }
    }, options);
  }

  return request("https://vip.video.qq.com/fcgi-bin/comm_cgi?name=".concat(name, "&cmd=").concat(cmd, "&otype=").concat(isJson ? 'xjson' : 'json'), params, options).then(function (res) {
    if (res && res.ret === -10) {
      throw new RequestError(res.ret, "CommCGI\u540D\u79F0\u672A\u914D\u7F6E(name=".concat(name, ")"), res, RequestErrorType.SYSTEM_ERR);
    }

    return res;
  });
}
/**
 * rpcCGI 支持调用 rpcGo 的接口
 * @param {string} path rpc路由
 * @param {object} data 参数
 * @param {object} options 请求设置
 * @example
 * // 请求接口 http://vip.video.qq.com/rpc/trpc.kidsvip.checkinfo.KidsVipService/KidsVipCheckInfo
 * try {
 *   await rpcCGI('trpc.kidsvip.checkinfo.KidsVipService/KidsVipCheckInfo')
 * } catch (e) {
 * }
 */

export function rpcCGI() {
  return _rpcCGI.apply(this, arguments);
}

function _rpcCGI() {
  _rpcCGI = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var path,
        data,
        options,
        type,
        others,
        method,
        url,
        res,
        _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            path = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
            data = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            options = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
            type = options.type, others = _objectWithoutProperties(options, ["type"]);
            method = (type || 'get').trim().toLowerCase();
            others.withCredentials = true;

            if (method === 'post') {
              others.headers = {
                'Content-Type': 'text/plain;charset=utf-8'
              };

              if (isPlainObject(data)) {
                data = JSON.stringify(data);
              }
            } else if (method === 'get' && isPlainObject(data) && !data.rpc_data) {
              // 兼容处理业务自己透传的 rpc_data 参数，不再处理
              data = {
                rpc_data: JSON.stringify(data)
              };
            }

            url = "//vip.video.qq.com/rpc/".concat(path);

            if (path.match(/^(https?:)?\/\//)) {
              url = path;
            }

            if (!IS_STD_PROTOCOL && /^\/\//.test(url)) {
              url = "https:".concat(url);
            }

            _context2.prev = 10;
            _context2.next = 13;
            return METHODS.get(method).call(this, url, data, others);

          case 13:
            res = _context2.sent;

            if (!(res && res.status === 200 && res.data)) {
              _context2.next = 18;
              break;
            }

            return _context2.abrupt("return", res.data);

          case 18:
            throw new RequestError(res.headers['trpc-func-ret'] || res.status || -999, res.headers['trpc-error-msg'] || '服务器开小差了！请重试', null, RequestErrorType.SYSTEM_ERR);

          case 19:
            _context2.next = 24;
            break;

          case 21:
            _context2.prev = 21;
            _context2.t0 = _context2["catch"](10);
            throw new RequestError(_context2.t0.code || 0, _context2.t0.msg || '网络开小差了！请重试', null, _context2.t0.errorType || RequestErrorType.NETWORK_ERR);

          case 24:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[10, 21]]);
  }));
  return _rpcCGI.apply(this, arguments);
}